<div class="preloader" *ngIf="isFullPreloader">
    <div class="loader">
        <div class="sbl-half-circle-spin">
            <div></div>
        </div>
    </div>
</div>

<div class="contained-preloader" *ngIf="!isFullPreloader">
    <div class="loader">
        <div class="sbl-half-circle-spin">
            <div></div>
        </div>
    </div>
</div>
